import styles from "./ProjectComponent.module.css";
import { NavLink } from "react-router-dom";
export default function ProjectComponent() {
	return (
		<div className={styles.container}>
			<div>
				<h2>Recent Projects</h2>
				<hr />
			</div>

			<div className={styles.card}>
				<h3>Stock Portfolio Manager</h3>
				<h4>Next.js App</h4>
				<p>
					A site where users can practice buying and selling stocks.
					Users can login using their gmail to save their mock
					portfolio. The site uses the marketstack api so the prices
					of the user's stocks are accuarate. In addition, the
					portfolio chart can track a hundred days of a stock's
					perfomance with accurate figures in USD. Users can own up to
					4 distinct stocks and 3 seperate buy orders of a given
					stock. This data is stored using Neon serverless postgress
					and intuitively interacts with my Next.js app using Prisma
					ORM. The site also supports language translation in English,
					Spanish and French using the next-intl library.
				</p>
				<NavLink to="/stock-portfolio-manager-showcase" className={styles.button}>See More</NavLink>
			</div>
			<div className={styles.card}>
				<h3>Food Blog</h3>
				<h4>Next.js App</h4>
				<p>
					A site where users can upload blog posts and interact with
					other user's posts. Users can login using their gmail to see
					their posts and comment on others. The site uses mongodb to
					store text content and supabase to allow users to upload a
					food image to their post. The site also uses the gemini API
					where users can pass in their current posts to be
					rewritten/expanded on. The site supports search allowing
					users to find post through key words.
				</p>
				<NavLink to="/food-blog-showcase" className={styles.button}>See More</NavLink>
			</div>
		</div>
	);
}
